import { constants, Styles } from '@/styles';

export const styles: Styles = {
  '.control-wrapper': {
    maxWidth: 330,
  },

  '.button': {
    marginTop: constants.offset.small,
  },
};
